<template>
	<template v-for="(seller, sellerIndex) in getAllSellers()" :key="passedMarketplaceData.marketIdentifier +'-'+ passedMarketIndex +'-' + seller + sellerIndex">
			<live-listings-seller
				:passed-seller="seller"
				:passed-seller-index="sellerIndex"
				:passed-listingsData="passedMarketplaceData?.listings?.[seller]"
				:passed-commandData="passedMarketplaceData?.commands?.[seller]"
				:passed-price-star-data="passedMarketplaceData?.priceStarInfo?.[seller]"
				:passed-market-data="passedMarketplaceData.marketData"
				:passed-mm-data="passedMmData[passedMarketplaceData.marketIdentifier]"
				:passed-total-row-span="getTotalRowCountForMarket()"
				:passed-market-index="passedMarketIndex"
				:passed-asin="passedAsin"
				:passed-ean="passedEan"
		/>
	</template>
</template>

<script>

import LiveListingsSeller from "./LiveListingsSeller.vue";

export default {
	components: {LiveListingsSeller},
	props: {
		passedMarketplaceData: {
			type: Object,
			required: true,
		},
		passedMmData: {
			type: Object,
			required: true,
		},
		passedMarketIndex: {
			type: Number,
			required: true,
		},
		passedAsin: {
			type: String,
			required: true,
		},
		passedEan: {
			type: String,
			required: true,
		}
	},
	methods: {
		getTotalRowCountForMarket() {
			let count = 0;
			const listingsData = this.passedMarketplaceData;

			const shouldLog = listingsData?.marketData?.id === 99999;

			if (shouldLog) console.log('ListingsData:', listingsData);

			if (!listingsData || !listingsData.listings) count =  0;
				// Iterate through each seller in listings
				Object.keys(listingsData?.listings)?.forEach(seller => {
					const sellerListings = listingsData?.listings?.[seller];
					if (shouldLog) console.log(`Processing seller [${seller}] listings:`, sellerListings);

						Object.keys(sellerListings)?.forEach(condition => {
							const listings = sellerListings?.[condition];
							if (shouldLog) console.log(`Condition [${condition}] listings count:`, listings.length);

							if (Array.isArray(listings)) {
								if (shouldLog) console.log(`Count: ${count}, seller: ${seller}, Condition [${condition}] - Listing`);
								count += listings.length;
							}
						});
				});
				// Iterate through each seller in commands
				Object.keys(listingsData?.commands)?.forEach(seller => {
					const sellerCommands = listingsData?.commands?.[seller];
					if (shouldLog) console.log(`Processing seller [${seller}] commands:`, sellerCommands);
						Object.keys(sellerCommands)?.forEach(condition => {
							if (shouldLog) console.log(`Condition [${condition}] commands count:`, sellerCommands?.[condition].commands.length );

							if (Array.isArray(sellerCommands?.[condition].commands)) {
								if (shouldLog) console.log(`Count: ${count}, seller: ${seller}, Condition [${condition}] - commands`);
								count += sellerCommands?.[condition].commands.length;
							}
						});
				});

			Object.keys(listingsData?.priceStarInfo || {})?.forEach(seller => {
				const sellerPriceStarInfo = listingsData?.priceStarInfo?.[seller];
				if (shouldLog) console.log(`Processing seller [${seller}] priceStarInfo:`, sellerPriceStarInfo);
				Object.keys(sellerPriceStarInfo)?.forEach(condition => {
					if (shouldLog) console.log(`priceStarInfo [${condition}] priceStarInfo count:`, sellerPriceStarInfo?.[condition].length );

					if (Array.isArray(sellerPriceStarInfo?.[condition])) {
						if (shouldLog) console.log(`Count: ${count}, seller: ${seller}, Condition [${condition}] - priceStarInfo`);
						count += sellerPriceStarInfo?.[condition].length;
					}
				});
			});


			if (shouldLog) console.log('Final count:', count);
			return count;
		},
		getAllSellers() {
			const order = ['MUL', 'COS', 'LDD', 'WRM'];
			const listings = this.passedMarketplaceData?.listings || {};
			const commands = this.passedMarketplaceData?.commands || {};
			const priceStarInfo = this.passedMarketplaceData?.priceStarInfo || {};

			const sellers = new Set([
				...Object.keys(listings),
				...Object.keys(commands),
				...Object.keys(priceStarInfo)
			]);

			return order.filter(seller => sellers.has(seller));
		}
	}
}
</script>
<style scoped>
.market-cell {
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
	border-right: 2px solid #ddd;
}

.vert-align {
	vertical-align: middle
}
</style>